import { Entity } from '@adornis/baseql/decorators.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

@Entity()
export class ProductIdeaFilter extends AdornisFilter {
  static override _class = 'ProductIdeaFilter';

  override searchFields: string[] | undefined = ['name'];
}
